<template>
  <div>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalElements"
      :loading="isSearching"
      item-key="id"
      locale="pt-BR"
      show-select
      class="elevation-3 mt-2"
    >
      <template v-slot:item.description="{item}">
        <coverage-descriptions
          :item="item"
          :coverage-descriptions="getCoverageDescriptions"
          @on-description-created="updateCoverageCarrier"
          class="mt-1 mb-1"
        >
        </coverage-descriptions>
      </template>
    </v-data-table>
    <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CoverageCarrierService from '@/services/odoo/CoverageCarrierService';
import CoverageDescriptions from '@/view/coverage/coverage_descriptions';
import DlgConfirmCancel from '@/components/dlg-confirm_cancel.vue';

export default {
  components: { CoverageDescriptions, DlgConfirmCancel },
  props: {
    coverageId: {
      type: String,
    },
  },
  data() {
    return {
      headers: [
        {text: 'CNPJ', value: 'documentNumber'},
        {text: 'Nome Fantasia', value: 'name'},
        {text: 'Razão Social', value: 'comercialName'},
        {text: 'Regra', value: 'description'},
      ],
      isSearching: false,
      options: {},
      items: [],
      totalElements: null,
      singleSelect: false,
      selected: [],
    };
  },
  async created() {
    this._service = new CoverageCarrierService();
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters('coverage', ['getCoverageDescriptions']),
  },
  methods: {
    ...mapActions('coverage', ['fetchCoverageDescriptions']),
    ...mapMutations(['toogleDialogLoading', 'showmsg']),
    async updateCoverageCarrier(
      coverageCarrier,
      coverageDescriptionId,
    ) {
      await this._service.update(coverageCarrier.id, coverageDescriptionId);
    },
    async loadData() {
      this.isSearching = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this._service.findAllByCoverageId(this.coverageId, {
          page: page ? page - 1 : 0,
          sortBy: sortBy && sortBy.length ? sortBy[0] === 'account.carrierName' ? 'carrier.name' : sortBy[0] : 'carrier.razaoSocial',
          descending: sortDesc && sortDesc.length ? sortDesc[0] : false,
          size: itemsPerPage,
        }).then((res) => {
          this.items = res.data.content;
          this.totalElements = res.data.totalElements;
          this.isSearching = false;
          this.$emit('on-load');
        });

      if (!this.getCoverageDescriptions.length) {
        this.fetchCoverageDescriptions().then();
      }
    },
    async removeAll() {
      if (this.selected.length && (await this.$refs.confirm.show('Atenção', 'Deseja excluir os registros selecionados?'))) {
        this.toogleDialogLoading(true);
        for (const coverageCarrier of this.selected) {
          await this._service.delete(coverageCarrier.id);
        }

        this.showmsg({text: 'Operadores desassociados com sucesso!'});
        this.toogleDialogLoading(false);
        await this.loadData();
      }
    },
  },
};
</script>
